module.exports = __webpack_public_path__ + "img/licence4.77360d2c.jpg";